import { render, staticRenderFns } from "./TransactionResultsDetails.vue?vue&type=template&id=2a228458&lang=html&"
import script from "./TransactionResultsDetails.vue?vue&type=script&lang=js&"
export * from "./TransactionResultsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports